import React from 'react';
import './Footer.css';

function Footer() {
  const navigate = (path) => {
    const event = new CustomEvent('navigate', { detail: path });
    window.dispatchEvent(event);
  };

  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-links">
          <a href="/privacy" onClick={(e) => { e.preventDefault(); navigate('/privacy'); }} className="footer-link">Privacy Policy</a>
          <a href="/terms" onClick={(e) => { e.preventDefault(); navigate('/terms'); }} className="footer-link">Terms of Service</a>
        </div>
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} Retrorocket Labs Oy. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
